import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AccountSidebar } from '../components/account/AccountSidebar';
import { PersonalInfoSection } from '../components/account/PersonalInfoSection';
import { OrderHistorySection } from '../components/account/OrderHistorySection';
import { AddressesSection } from '../components/account/AddressesSection';
import { SecuritySection } from '../components/account/SecuritySection';
import { PreferencesSection } from '../components/account/PreferencesSection';
import { SubscriptionManager } from '../components/account/SubscriptionManager';
import { PetsSection } from '../components/account/PetsSection';
export function AccountPage() {
  return <div className="bg-[#FAF7F2] min-h-screen pt-24 sm:pt-32 pb-20 font-sans" data-id="element-5616">
      <div className="container-custom" data-id="element-5617">
        {/* Header */}
        <div className="mb-12 text-center md:text-left" data-id="element-5618">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#2C3333] mb-4 tracking-tight font-serif" data-id="element-5619">
            Mi Cuenta
          </h1>
          <p className="text-gray-500 text-lg max-w-2xl" data-id="element-5620">
            Gestiona tus pedidos, direcciones y preferencias personales desde tu
            panel de control.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-5621">
          {/* Sidebar */}
          <div className="lg:col-span-3" data-id="element-5622">
            <div className="sticky top-32" data-id="element-5623">
              <AccountSidebar data-id="element-5624" />
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-9" data-id="element-5625">
            <div className="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 p-8 sm:p-12 min-h-[600px] relative overflow-hidden" data-id="element-5626">
              {/* Decorative background */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#7C9885]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-5627"></div>

              <div className="relative z-10" data-id="element-5628">
                <Routes data-id="element-5629">
                  <Route path="/" element={<PersonalInfoSection data-id="element-5631" />} data-id="element-5630" />
                  <Route path="/orders" element={<OrderHistorySection data-id="element-5633" />} data-id="element-5632" />
                  <Route path="/subscriptions" element={<SubscriptionManager data-id="element-5635" />} data-id="element-5634" />
                  <Route path="/pets" element={<PetsSection data-id="element-5637" />} data-id="element-5636" />
                  <Route path="/addresses" element={<AddressesSection data-id="element-5639" />} data-id="element-5638" />
                  <Route path="/security" element={<SecuritySection data-id="element-5641" />} data-id="element-5640" />
                  <Route path="/preferences" element={<PreferencesSection data-id="element-5643" />} data-id="element-5642" />
                  <Route path="*" element={<Navigate to="/cuenta" replace data-id="element-5645" />} data-id="element-5644" />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}